import React from "react";
import classes from "../homepage/Team.module.css";
import ultraImg from "../../assets/ultra.png";
import headvillianImg from "../../assets/headvillian.png";
import web3img from "../../assets/meow.png";
import dimImg from "../../assets/dim.png";
import planetYellow from "../../assets/Planet_yellow.png";
import buildingImg from "../../assets/Buildings_Foreground.png";

const Team: React.FC = () => {
  return (
    <div className={classes["team-wrapper"]}>
      <div className={classes["team-content-wrapper"]}>
        <h2 className={classes["team-title"]}>Meet the Team</h2>
        <div className={classes["team-content-inner-wrapper"]}>
          <div className={classes["team-inner-wrapper"]}>
            <img className={classes["team-img"]} src={ultraImg} alt="" />
            <div className={classes["team-text"]}>
              <div className={classes["team-role"]}>Project Lead</div>
              <div className={classes["team-name"]}>0xUltra</div>
            </div>
          </div>
          <div className={classes["team-inner-wrapper"]}>
            <img className={classes["team-img"]} src={headvillianImg} alt="" />
            <div className={classes["team-text"]}>
              <div className={classes["team-role"]}>Marketing</div>
              <div className={classes["team-name"]}>HeadAnimeVillain</div>
            </div>
          </div>
          <div className={classes["team-inner-wrapper"]}>
            <img className={classes["team-img"]} src={web3img} alt="" />
            <div className={classes["team-text"]}>
              <div className={classes["team-role"]}>Web3</div>
              <div className={classes["team-name"]}>Me-ow</div>
            </div>
          </div>
          <div className={classes["team-inner-wrapper"]}>
            <img className={classes["team-img"]} src={dimImg} alt="" />
            <div className={classes["team-text"]}>
              <div className={classes["team-role"]}>Artist</div>
              <div className={classes["team-name"]}>Dim</div>
            </div>
          </div>
        </div>
      </div>
      <img className={classes["planet-brown"]} src={planetYellow} alt="" />
      {/* <!-- 
      <img className="cloud2" src="../assets/Cloud_1.png" alt="" />
    --> */}
      <img className={classes["buildings"]} src={buildingImg} alt="" />
    </div>
  );
};

export default Team;
